import React, { useState, useEffect } from "react";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useHistory } from "react-router-dom";

// Icons
import LocalShippingTwoToneIcon from "@material-ui/icons/LocalShippingTwoTone";
import ShoppingCartTwoToneIcon from "@material-ui/icons/ShoppingCartTwoTone";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ShoppingBasketTwoToneIcon from "@material-ui/icons/ShoppingBasketTwoTone";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";

// Components

//React Router (for getting parameters)
import { useParams, NavLink } from "react-router-dom";

//number format plugin
import numeral from "numeral";

import { PDFDownloadLink } from "@react-pdf/renderer";
import { PdfDocument } from "../../components/PDF/AccountUpgradeReleasePdf";
import Autocomplete from "@material-ui/lab/Autocomplete";
import MessageBox from "../../components/MessageBox/MessageBox";
import LoadingModal from "../../components/Modal/LoadingModal";
//cookies

import Preloader from "../../components/Preloader/Preloader";
import CountryTagOrderTable from "./AccountUpgradeTable";
import { get_cookies, timeZoneChanger } from "../../components/Cookies/Cookies";

const useStyles = makeStyles({
  card: {
    marginBottom: "1rem",
  },
  cardHeader: {
    borderBottom: "1px solid #33993312",
    padding: "1.3rem 24px 2rem 24px",
  },
  title: {
    marginTop: "0",
    color: "#339933",
    fontWeight: "700",
    fontSize: "1.1rem",
  },
  subTitle: {
    fontSize: "0.8rem",
    marginBottom: "0.5rem",
    fontWeight: "700",
    textTransform: "uppercase",
    color: "#9f9f9f",
  },
  infoContainer: {
    marginBottom: "2rem",
    backgroundColor: "#33993312",
    padding: "1rem",
    border: "1.5px solid #33993312",
    borderRadius: "5px",
  },
  infoTitle: {
    fontWeight: "700",
    fontSize: "14px",
  },
  infoContent: {
    fontSize: "14px",
  },
  buttonContainer: {
    textAlign: "right",
    "& button": {
      marginLeft: "0.5rem !important",
    },
  },
  wayBillbuttonContainer: {
    textAlign: "right",
    "& button": {
      marginLeft: "0.5rem !important",
    },
    marginTop: "1rem !important",
    marginRight: "1rem !important",
  },
  infoTotal: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    marginTop: "1rem",
  },
  infoTotalItem: {
    padding: "0.5rem 1rem",
    border: "1px solid #33993312",
    borderRadius: "5px",
    display: "flex",
    alignItems: "center",
    marginBottom: "0.5rem",
    fontWeight: "700",
  },
  infoTotalIcon: {
    marginRight: "0.5rem",
    color: "#4caf50 !important",
  },
  textarea: {
    width: "100%",
    marginTop: "1rem",
  },
});

const AccountUpgradeDetails = () => {
  const { id, flag } = useParams();
  const [soInfo, setSoInfo] = useState(null);
  const classes = useStyles();

  const [items, setItems] = useState([]); //data to display in item table
  const [payments, setPayments] = useState([]); //data to display in item table
  const [showPDF, setShowPdf] = useState(false);
const [selectedWarehouse, setSelectedWarehouse] = useState(null);
  const [shipping, setShipping] = useState([]);
  const [warehouse, setWarehouse] = useState([]);
  const [upgDetails, setUpgDetails] = useState([]);
  const [packages, setPackage] = useState([]);
  const [shippingId, setShippingId] = useState("");
  const [shippingName, setShippingName] = useState("");
  const [warehouseId, setWarehouseId] = useState("");
  const [refno, setRefno] = useState("");
  const [isReleased, setIsReleased] = useState(false);
  const [grandtotal, setGrandTotal] = useState(0);
  const [releasedDate, setReleasedDate] = useState(null);
  const [isHqReleased, setIsHqReleased] = useState(null);
  const [isMainReleased, setIsMainReleased] = useState(null);
  const [branchinfo, setBranchInfo] = useState(null);
  const [package_obj, setPackageObj] = useState(null);
  let history = useHistory();

  //Message Box
  const [showMsgBox, setShowMsgBox] = useState(false);
  const [msgBoxContent, setMsg] = useState("Empty");
  const [msgType, setMsgType] = useState("success");
  //Message Box EOF
  //state for managing loading modal
  const [showModal, setShowModal] = useState(false);
  //state for disabling/enabling button
  const [btnDisabled, setBtnDisabled] = useState(true);
  // componentDidMount / document.ready ?
  useEffect(() => {
    data();
  }, []);
useEffect(() => {
  if (warehouse.length > 0) {
    setSelectedWarehouse(warehouse[0]);
    setWarehouseId(warehouse[0].id);
  }
}, [warehouse]);

  const x = 0;
  useEffect(() => {
    //
    // isLoggedIn();
  }, [x]);

  const selectShippingProps = {
    options: shipping,
    getOptionLabel: (option) => option.description,
  };

  const selectLocationProps = {
    options: warehouse,
    getOptionLabel: (option) => option.description,
  };

  useEffect(() => {
    if (warehouseId && soInfo) {
      setBtnDisabled(false); // re-enable
    } else {
      setBtnDisabled(true); // re-enable
    }
  }, [refno, shippingId, warehouseId, soInfo]);


  const data = async () => {
    await axios
      .get(process.env.REACT_APP_API_URL + "get_details_account", {
        params: {
          idno: id,
          jc_u_idno: get_cookies("branchidno"),
          username: get_cookies("username"),
        },
      })
      .then((res) => {
        // console.log(res.data);
        setPackage(res.data.countrytag_package[0]);
        setPackageObj(res.data.countrytag_package[0]);
        setItems(res.data.countrytag_packagesitem);
        setBranchInfo(res.data.branchinfo);
        setSoInfo(res.data.distributor_info);
        setUpgDetails(res.data.countrytag_upgrade_details);
        setShipping(res.data.countrytag_shipping);
        setIsHqReleased(res.data.is_hq_released);
        setIsMainReleased(res.data.is_main_released);
        setGrandTotal(
          parseFloat(res.data.countrytag_shipping[0].shipping_fee) +
            parseFloat(res.data.countrytag_upgrade_details.amount)
        );
        // setWarehouse(res.data.get_location);
        if (
          res.data.is_released?.is_released === 0 ||
          res.data.is_released == null
        ) {
          setIsReleased(true);
        } else {
          setReleasedDate(res.data.is_released.date_released);
          setIsReleased(false);
          setShowPdf(true);
        }
       
        getWarehouse();

        // setPayments(res.data.data.customer_alloc);
        // if (res.data.data.order_details) {
        //   setShowPdf(true);
        // }
        //total_payment = res.data.data.cp_payments+res.data.data.b1t1_payments+res.data.data.ppv_payments+res.data.data.dragonpay_payments+res.data.data.paypanda_payments+res.data.data.asiapay_payments+res.data.data.ipay_payments;
      })
      .catch((error) => {
        // console.log(error.message);
      });
  };
  const headerss = {
    "Content-Type": "multipart/form-data",
    "Access-Control-Allow-Origin": process.env.REACT_APP_API_URL,
  };
    const validate_packageitem_count = () => {
         setBtnDisabled(!btnDisabled);
         setShowModal(true); //show loading/please wait modal
      //get data for warehouse/location dropdown
      const updated_package_obj = {
        ...package_obj,
        packagename: package_obj.package_name,
      };
      
      delete updated_package_obj.package_name;
      
      const form_data = {
        package_obj: [updated_package_obj],
        packageid: packages.packageid,
        branchidno: get_cookies("branchidno"),
      };
      const formData = new FormData();
      formData.append("form_data", JSON.stringify(form_data));
      const apiUrl = process.env.REACT_APP_API_URL + "checkiteminventory";
      axios.post(apiUrl, formData, { headers: headerss }).then((res) => {
        if (res.data.is_insufficient == "no") {
          checkifRelease();
        } else {
          setShowModal(false); //show loading/please wait modal
          setShowMsgBox(true);
          setMsg(
            "Insufficient inventory quantity for the chosen Wholesale Set. You may contact our head office for your products."
          );
          setMsgType("warning");
          setTimeout(() => {
            setBtnDisabled(false);
            setShowMsgBox(false);
          }, 3000);
        }
      });
    };
  const checkifRelease = async () => {
    await axios
      .post(process.env.REACT_APP_API_URL + "check_release_status", {
        idno: upgDetails.reference_no,
      })
      .then((res) => {
        if (res.data.status === 0 || res.data.status == null) {
          release_online_orders();
        } else {
          setShowMsgBox(true);
          setMsg("The set has already been released.");
          setMsgType("warning");
          setTimeout(() => {
            setShowMsgBox(false);
            setBtnDisabled(false); // re-enable
          }, 2500);
        }

        // getWarehouse();

        // setPayments(res.data.data.customer_alloc);
        // if (res.data.data.order_details) {
        //   setShowPdf(true);
        // }
        //total_payment = res.data.data.cp_payments+res.data.data.b1t1_payments+res.data.data.ppv_payments+res.data.data.dragonpay_payments+res.data.data.paypanda_payments+res.data.data.asiapay_payments+res.data.data.ipay_payments;
      })
      .catch((error) => {
        // console.log(error.message);
      });
  };

  const getDisplayLocation = () => {
    if (upgDetails.payment_type !== "OTCHQ") {
      if (branchinfo.region === "Luzon" || branchinfo.country !== "Philippines") return "Main Office";
      if (branchinfo.region === "Mindanao") return "Davao Head Quarters";
      if (branchinfo.region === "Visayas/Naga/Legaspi") return "Cebu Head Quarters";
    }
    if (upgDetails.payment_type === "OTCHQ") {
      return upgDetails.payment_location.replace("HQ", " Head Quarters");
    }
    return "";
  };
  const getWarehouse = async () => {
    //get data for location/warehouse dropdown
    const res = await axios.get(
      process.env.REACT_APP_API_URL + "/get_warehouse_list"
    );
    setWarehouse(res.data.data);
  };
  const release_online_orders = async () => {
    setBtnDisabled(true); // disable button to avoid multiple saves


    const date = timeZoneChanger(); // get the date string

    const formData = new FormData();
    formData.append("idno", soInfo.idno);
    formData.append("itemlocid", warehouseId);
    formData.append("reference_no", upgDetails.reference_no);
    formData.append("oldatype", upgDetails.old_atype);
    formData.append("newatype", upgDetails.new_atype);
    formData.append("oldtagtype", upgDetails.old_tagtype);
    formData.append("newtagtype", upgDetails.new_tagtype);
    formData.append("username", get_cookies("username"));
    formData.append("jc_u_idno", get_cookies("branchidno"));
    formData.append("trandate", date);

    await axios
      .post(
        process.env.REACT_APP_API_URL + "release_package_account",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then(function (res) {
        setShowModal(false); //hide loading/please wait modal
        setShowMsgBox(true);
        setMsg("Successfully Released #" + id);
        setMsgType("success");
        setTimeout(() => {
          setShowMsgBox(false);
          setBtnDisabled(false); // re-enable
          history.push("/sales/upgrade-package-release");
        }, 2000);
      })
      .catch(function (error) {
        setShowModal(false); //hide loading/please wait modal
        setShowMsgBox(true);
        setMsg("Something went wrong: " + error);
        setMsgType("warning");
        setTimeout(() => {
          setShowMsgBox(false);
          setBtnDisabled(false); // re-enable
        }, 2500);
      });
  };

  return (
    <div className="page">
      <div className="page-header">
        <div className="page-icon">
          <ShoppingCartIcon />
        </div>
        {/* <img src={logo} width="100" height="50" alt="jc logo"/> */}
        <NavLink to={"/Wholesale"}>
          <h2 style={{ color: "black" }}>Wholesale Set</h2>
        </NavLink>
        <ArrowForwardIosIcon
          style={{ paddingLeft: "10px", paddingRight: "10px" }}
        />
        <NavLink to={"/sales/country-tag-upgrade"}>
          <h2 style={{ color: "black" }}>
            Account Upgrade Wholesale Set Release
          </h2>
        </NavLink>
        <ArrowForwardIosIcon
          style={{ paddingLeft: "10px", paddingRight: "10px" }}
        />
        <h2>Account Upgrade Wholesale Set Release Details</h2>
      </div>
      {soInfo ? (
        <div className="page-container">
          <MessageBox in={showMsgBox} content={msgBoxContent} type={msgType} />
          <LoadingModal showModal={showModal} />
          <Card className={classes.card}>
            <div className={classes.cardHeader}>
              <Grid
                container
                spacing={0}
                style={{ justifyContent: "flex-end" }}
              >
                {/* <Grid item xs={8}>
                  <div className={classes.title}>Online Sales Order View</div>
                </Grid> */}
                <Grid item xs={2} style={{ textAlign: "right" }}></Grid>
                <Grid item xs={2} className={classes.buttonContainer}></Grid>
              </Grid>
            </div>
            <CardContent>
              {soInfo ? (
                <Grid container spacing={2}>
                  {releasedDate !== null ? (
                    <div
                      style={{
                        backgroundColor: "#dff0d8",
                        color: "#3c763d",
                        padding: "12px 16px",
                        borderRadius: "4px",
                        width: "100%",
                        border: "1px solid #d6e9c6",
                        marginBottom: "16px",
                      }}
                    >
                      <strong>Note:</strong> This Wholesale Set has already been
                      released.
                    </div>
                  ) : null}
                  {isHqReleased == null && isMainReleased  == null? (
                    <div
                    style={{
                      backgroundColor: "#fcf8e3",     // light orange background
                      color: "#8a6d3b",               // dark orange/brown text
                      padding: "12px 16px",
                      borderRadius: "4px",
                      width: "100%",
                      border: "1px solid #faebcc",   // light orange border
                      marginBottom: "16px",
                    }}
                    >
                      <strong>Note:</strong> This Wholesale Set has not been
                      process by {getDisplayLocation()}.
                    </div>
                  ) : null}


                  <Grid item xs={12} sm={12} md={12} lg={5}>
                    <div className={classes.infoContainer}>
                      <Grid
                        container
                        justifyContent="space-between"
                        spacing={2}
                      >
                        <Grid item xs={12} sm={12}>
                          <Grid container spacing={3}>
                            <Grid
                              item
                              xs={12}
                              sm={4}
                              className={classes.infoTitle}
                            >
                              ID No:
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sm={8}
                              className={classes.infoContent}
                            >
                              {soInfo.idno}
                            </Grid>
                          </Grid>
                          <Grid container spacing={3}>
                            <Grid
                              item
                              xs={12}
                              sm={4}
                              className={classes.infoTitle}
                            >
                              Name:
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sm={8}
                              className={classes.infoContent}
                            >
                              {soInfo.fname} {soInfo.mname || " "}{" "}
                              {soInfo.lname}
                            </Grid>
                          </Grid>
                          <Grid container spacing={2}>
                            <Grid
                              item
                              xs={12}
                              sm={4}
                              className={classes.infoTitle}
                            >
                              Shipping Details:
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sm={4}
                              className={classes.infoContent}
                            >
                              <Grid
                                item
                                xs={12}
                                sm={4}
                                className={classes.infoContent}
                              >
                                Pick Up
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid container spacing={3}>
                            <Grid
                              item
                              xs={4}
                              sm={4}
                              className={classes.infoTitle}
                            >
                              Set Selected:
                            </Grid>
                            <Grid
                              item
                              xs={4}
                              sm={4}
                              className={classes.infoContent}
                            >
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                className={classes.infoContent}
                              >
                                {packages.package_name}
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid container spacing={3}>
                            <Grid
                              item
                              xs={4}
                              sm={4}
                              className={classes.infoTitle}
                            >
                              Received From:
                            </Grid>
                            <Grid
                              item
                              xs={4}
                              sm={4}
                              className={classes.infoContent}
                            >
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                className={classes.infoContent}
                              >
                                
                  {getDisplayLocation()}
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                      {/* <Grid
                        container
                        justifyContent="space-between"
                        spacing={2}
                      >
                        <Grid  container spacing={3}>
                          <Grid
                            item
                            xs={12}
                            sm={4}
                            className={classes.infoTitle}
                          >
                            Shipping Details:
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            sm={4}
                            className={classes.infoTitle}
                          >
                            Pick Up
                          </Grid>
                        </Grid>
                        <Grid  container spacing={3}>
                        <Grid
                            item
                            xs={12}
                            sm={4}
                            className={classes.infoContent}
                          >
                            Delivery Type:
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            sm={4}
                            className={classes.infoTitle}
                          >
                            Wholesale Set Details:
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            sm={4}
                            className={classes.infoTitle}
                          >
                            Set Selected:
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            sm={8}
                            className={classes.infoContent}
                          >
                            {packages.package_name}
                          </Grid>
                        </Grid>
                      </Grid> */}
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={5}>
                    <div className={classes.infoContainer}>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={4} className={classes.infoTitle}>
                          Transaction Date:
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={8}
                          className={classes.infoContent}
                        >
                          {upgDetails.date_created}
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={4} className={classes.infoTitle}>
                          Payment Date:
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={8}
                          className={classes.infoContent}
                        >
                          {upgDetails.date_paid}
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={4} className={classes.infoTitle}>
                          Reference No:
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={8}
                          className={classes.infoContent}
                        >
                          {upgDetails.reference_no}
                        </Grid>
                      </Grid>
                      {releasedDate !== null ? (
                        <Grid container spacing={3}>
                          <Grid
                            item
                            xs={12}
                            sm={4}
                            className={classes.infoTitle}
                          >
                            Released Date:
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            sm={8}
                            className={classes.infoContent}
                          >
                            {releasedDate}
                          </Grid>
                        </Grid>
                      ) : null}
                    </div>
                  </Grid>
                </Grid>
              ) : (
                <></>
              )}

              <h4>Item Details</h4>
              <CountryTagOrderTable items={items} />

              {isReleased == true ? (
                <Grid container spacing={1}>
                  <Grid item xs={12} lg={6}>
                    <Autocomplete
                      {...selectLocationProps}
                      id="auto-complete-2"
                      autoComplete
                      includeInputInList
                        value={selectedWarehouse} 
                      onChange={(event, newValue) => {
                        if (newValue) {
                          setSelectedWarehouse(newValue);
                          setWarehouseId(newValue.id);
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          margin="normal"
                          label="Warehouse Location"
                          variant="outlined"
                        />
                      )}
                      // onChange={(event, newValue) => {
                      //   if (!newValue == "" || !newValue == null) {
                      //     //console.log(newValue.description);
                      //     setWarehouseId(newValue.id);
                      //   }
                      // }}
                    />
                  </Grid>
                </Grid>
              ) : (
                <></>
              )}
            </CardContent>
          </Card>
          <div className={classes.buttonContainer}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12} lg={12}>
                {showPDF && (
                  <PDFDownloadLink
                    document={
                      <PdfDocument
                        headers={upgDetails}
                        soInfo={soInfo}
                        items={items}
                        packages={packages}
                      />
                    }
                    fileName={
                      "AccountUpgrade#" + upgDetails.reference_no + ".pdf"
                    }
                    style={{
                      textDecoration: "none",
                      padding: "8px 11px",
                      color: "#fff",
                      display: "inline-block",
                      marginBottom: "7px",
                      fontFamily: "Ubuntu",
                      backgroundColor: "#339933",
                      border: "1px solid #339933",
                      borderRadius: "4px",
                    }}
                  >
                    {({ blob, url, loading, error }) =>
                      loading ? "Loading document..." : "Print"
                    }
                  </PDFDownloadLink>
                )}
                {isHqReleased == null && isMainReleased  == null? null:isReleased == true ? (
                  <Button
                    disabled={btnDisabled}
                    onClick={() => {
                      validate_packageitem_count();
                    }}
                    variant="contained"
                    color="primary"
                  >
                    Release
                  </Button>
                ) : (
                  <></>
                ) }

              </Grid>
            </Grid>
          </div>
        </div>
      ) : (
        <Preloader />
      )}
    </div>
  );
};

export default AccountUpgradeDetails;
